// 获取光标选中得文本内容
function getSelectText() {
    return window.getSelection ? window.getSelection().toString() : document.selection.createRange().text;
}
// 光标保持在末位
function keepCursorEnd(obj) {
    // ie11 10 9 firefox safari
    if (window.getSelection) {
        // 解决firefox不获取焦点无法定位问题

        // 创建range
        let range = window.getSelection();

        // range 选择obj下所有子内容
        range.selectAllChildren(obj);

        // 光标移至最后
        range.collapseToEnd();
    } else if (document.selection) {
        //ie10 9 8 7 6 5
        // 创建选择对象
        let range = document.selection.createRange();

        //range定位到obj
        range.moveToElementText(obj);

        //光标移至最后
        range.collapse(false);
        range.collapseToEnd();
        range.select();
    }
}
// 光标选中所有内容
function rangeSelectAll(obj) {
    if (window.getSelection) {
        // 解决firefox不获取焦点无法定位问题
        // 创建range
        let range = window.getSelection();
        // range 选择obj下所有子内容
        range.selectAllChildren(obj);
    } else if (document.selection) {
        //ie10 9 8 7 6 5
        // 创建选择对象
        let range = document.selection.createRange();
        //range定位到obj
        range.moveToElementText(obj);
        range.select();
    }
}
// 聚焦时选中所有内容

// 动态获取图片
const getAssetsImages = (name) => {
    return new URL(`../images/icon/${name}@3x.png`, import.meta.url).href;
};
export { getSelectText, keepCursorEnd, getAssetsImages, rangeSelectAll };
